import { Button, Flex, Icon, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { FaCheck } from "react-icons/fa";

// t('{{count}} requirements added') t('Undo')

interface Props {
  count: number;
  onUndo: () => void;
}

/**
 * Confirmation for a batch added from the library, shown in the section itself rather than as a toast
 * or a dialog: the requirements are already in the list behind it, and Undo is the only thing the user
 * might still want. It disappears the next time the section changes.
 */
export const AddedFromLibraryBanner = ({ count, onUndo }: Props) => {
  const { t } = useTranslation();
  return (
    <Flex
      align="center"
      gap="2"
      bg="smSuccessSoft"
      borderWidth="1px"
      borderColor="smSuccessSoftBorder"
      borderRadius="lg"
      px="4"
      py="2.5"
      mb="4"
    >
      <Icon as={FaCheck} color="smSuccess" boxSize="3" />
      <Text fontSize="sm" color="smSuccess">
        {t("{{count}} requirements added", { count })}
      </Text>
      <Button variant="link" size="sm" colorScheme="teal" ml="auto" onClick={onUndo}>
        {t("Undo")}
      </Button>
    </Flex>
  );
};
